/**
 * Map Loading Skeleton Component - Placeholder states during data loading
 */
import { useTranslation } from "react-i18next";
import "./MapLoadingSkeleton.css";

export interface MapLoadingSkeletonProps {
    isLoading?: boolean;
    message?: string;
}

export const MapLoadingSkeleton = ({
    isLoading = false,
    message
}: MapLoadingSkeletonProps): JSX.Element | null => {
    const { t } = useTranslation();

    if (!isLoading) {
        return null;
    }

    return (
        <div
            className="map-loading-skeleton"
            role="status"
            aria-live="polite"
            aria-label={message ?? t("map.loading.message")}
        >
            <div className="map-loading-skeleton__spinner" aria-hidden="true">
                <div className="map-loading-skeleton__spinner-circle"></div>
            </div>
            <p className="map-loading-skeleton__message">
                {message ?? t("map.loading.message")}
            </p>
        </div>
    );
};